export class CookieModel {
	Id_session: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/cookie-model.ts